import { entitlementsSchema, healthSchema, organizationEnvelopeSchema, } from '../schemas/organization.js';
export class OrganizationsApi {
    transport;
    constructor(transport) {
        this.transport = transport;
    }
    /**
     * The tenant, as resolved from the token claim.
     *
     * Note there is no `orgId` parameter anywhere in this package. The tenant is taken from
     * the verified claim server side and never from a body or a query parameter — a caller
     * must not be able to name the organization it operates on, and a client that could
     * pass one would make that mistake reachable.
     */
    me(signal) {
        return this.transport
            .request({
            method: 'GET',
            path: '/v1/organizations/me',
            schema: organizationEnvelopeSchema,
            signal,
        })
            .then((r) => r.organization);
    }
    /**
     * What the plan allows.
     *
     * For rendering only. Invariant 7: the server re-checks on every gated route, so a 403
     * can still arrive after this said yes — a plan can change between the query and the
     * click, and a stale cache is not a security hole only because the server does not
     * trust this answer either.
     */
    entitlements(signal) {
        return this.transport.request({
            method: 'GET',
            path: '/v1/me/entitlements',
            schema: entitlementsSchema,
            signal,
        });
    }
    /** Liveness, plus which side of the mode switch this deployment is on. */
    health(signal) {
        return this.transport.request({
            method: 'GET',
            path: '/health',
            schema: healthSchema,
            signal,
        });
    }
}
//# sourceMappingURL=organizations.js.map